import { render, staticRenderFns } from "./FormMRS.vue?vue&type=template&id=dc13f5ec&"
import script from "./FormMRS.vue?vue&type=script&lang=js&"
export * from "./FormMRS.vue?vue&type=script&lang=js&"
import style0 from "./FormMRS.vue?vue&type=style&index=0&id=dc13f5ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports